export const baseUrl = '/Client/api';



// WEBPACK FOOTER //
// ./src/api/baseUrl.ts